// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"6b8b129f","453":"4781e615"}[chunkId] + ".chunk.js";
};